'use client';

import { ComponentType, memo } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  /** 동적 HTML 요소 */
  as?: string | ComponentType<any> | undefined;
  /** className */
  className?: string;
}

const Skeleton = ({ as, className }: IProps) => {
  const param: any = {
    className: classNameBind(['skeleton', className || '']),
    as,
  };

  return <S.Skeleton {...param} />;
};

export default memo(Skeleton);
